var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5425 31.09L21.0213 31.9434L21.5425 31.09C20.9025 30.6991 20.0975 30.6991 19.4575 31.09L19.9787 31.9434L19.4575 31.09L8.8054 37.5962L11.7015 25.455C11.8756 24.7254 11.6268 23.9599 11.0572 23.472L1.57774 15.3518L14.0197 14.3543C14.7673 14.2944 15.4185 13.8212 15.7066 13.1288L20.5 1.60396L25.2934 13.1288C25.5815 13.8212 26.2327 14.2944 26.9803 14.3543L39.4223 15.3518L29.9428 23.472C29.3732 23.9599 29.1244 24.7254 29.2985 25.4549L32.1946 37.5962L21.5425 31.09Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineStar);
export default __webpack_public_path__ + "static/media/outlineStar.bc7b781e62837661778398947be5a3a6.svg";
export { ForwardRef as ReactComponent };